import React from "react";

// Dynamic summary component
export const SummaryStep = ({ summaryData }: { summaryData: any[] }) => {
  return (
    <div className="space-y-6 p-4">
      {summaryData.map((section, sectionIdx) => (
        <div key={sectionIdx}>
          <h3 className="text-sm font-semibold text-muted-foreground mb-2">{section.title}</h3>
          <div className="grid grid-cols-2 gap-y-1 text-sm">
            {section.fields.map((field: any, fieldIdx: number) => (
              <div key={fieldIdx} className="flex gap-1">
                <span className="text-muted-foreground font-medium">{field.label}</span>
                <span className="font-semibold">{field.value}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
